<div class="verification-shell">
  <section class="verification-card" aria-labelledby="verification-title">
    <a routerLink="/login" class="back-link"><ion-icon name="arrow-back-outline"></ion-icon> Back to sign in</a>
    <div class="verification-mark"><ion-icon name="shield-checkmark-outline"></ion-icon></div>
    <h1 id="verification-title" class="bw-title-with-info">
      Verify it is you
      <app-info-tooltip compact placement="right" text="Choose one of your configured verification methods to complete this sign-in securely."></app-info-tooltip>
    </h1>

    @if (errorMessage) { <div class="message message--error">{{ errorMessage }}</div> }
    @if (infoMessage) { <div class="message message--info">{{ infoMessage }}</div> }

    @if (isLoading && methods.length === 0) {
      <div class="loading"><ion-spinner name="crescent"></ion-spinner><span>Loading your verification options...</span></div>
    } @else {
      <div class="method-switcher" role="tablist" aria-label="Verification method">
        @if (hasTotpMethod) {
          <button type="button" [class.active]="selectedMethod === 'totp'" (click)="chooseMethod('totp')"><ion-icon name="key-outline"></ion-icon> Authenticator app</button>
        }
        @if (hasEmailMethod) {
          <button type="button" [class.active]="selectedMethod === 'email'" (click)="chooseMethod('email')"><ion-icon name="mail-outline"></ion-icon> Email</button>
        }
      </div>

      @if (selectedMethod === 'email') {
        <div class="method-copy">
          <strong>Use your email</strong>
          <span>We will send a single-use code to your account email address.</span>
        </div>
        <button type="button" class="secondary-action" [disabled]="isSendingCode" (click)="sendEmailCode()">
          @if (isSendingCode) { <ion-spinner name="crescent"></ion-spinner> } @else { {{ emailCodeSent ? 'Send a new code' : 'Send verification code' }} }
        </button>
      } @else if (selectedMethod === 'totp') {
        <div class="method-copy">
          <strong>Open your authenticator app</strong>
          <span>Enter the current six-digit code for BizzWeaver.</span>
        </div>
      } @else {
        <div class="method-copy">
          <strong>Use a recovery code</strong>
          <span>Recovery codes are single use. Save the remaining codes after you sign in.</span>
        </div>
      }

      <form (ngSubmit)="verify()" class="verify-form">
        <label for="verification-code">{{ selectedMethod === 'recovery' ? 'Recovery code' : 'Verification code' }}</label>
        <input
          id="verification-code"
          [(ngModel)]="code"
          name="verificationCode"
          [attr.inputmode]="selectedMethod === 'recovery' ? null : 'numeric'"
          [autocomplete]="selectedMethod === 'recovery' ? 'off' : 'one-time-code'"
          [placeholder]="selectedMethod === 'recovery' ? 'ABCD-EFGH' : (selectedMethod === 'email' ? '8-digit code' : '6-digit code')"
          [class.code-input]="selectedMethod !== 'recovery'"
          required
        />
        <button type="submit" class="primary-action" [disabled]="isLoading || !code.trim()">
          @if (isLoading) { <ion-spinner name="crescent"></ion-spinner> } @else { Verify and sign in }
        </button>
      </form>

      <button type="button" class="recovery-link" (click)="chooseMethod('recovery')">Use a recovery code instead</button>
    }
  </section>
</div>
